import { Ticket } from "@/models/ticket";
import { Pagination } from "@/models/pagination";
import { ITicket, TicketState } from "@/types/ticket";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<TicketState, ITicket> = {
  single: (state, single) => {
    state.single = new Ticket(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Ticket(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Ticket();
    state.pagination = new Pagination();
  },
};

export default mutations;
